export default __webpack_public_path__ + "static/media/home-freelancer-bg-img-01.cd9a5e72.jpg";